module.exports = __webpack_public_path__ + "img/tool_select_icon.20c7235c.svg";